export function getUserActionsDateTime(doc) {
    var _a;
    return (_a = doc.user_relationship) === null || _a === void 0 ? void 0 : _a.last_action_datetime;
}
export function safeParseDate(dateString) {
    try {
        if (dateString) {
            return new Date(dateString);
        }
    }
    catch (_a) {
        /* do nothing */
    }
    return undefined;
}
//# sourceMappingURL=DateUtilities.js.map